export default __webpack_public_path__ + "static/media/4.844a95a5.svg";